exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.am-textarea[data-v-c8a25e1e] {\n  background: white;\n  margin-top: 5px;\n  width: 500px;\n  height: 250px;\n  max-width: 500px;\n}\n", ""]);

// exports
